export { FinanceIcon } from "./finance";
